namespace RecordShield.Workspace {
    export interface CreditConsumptionRow {
        ID?: number;
        TotalPurchased?: number;
        TotalConsumed?: number;
        Balance?: number;
        InsertDate?: string;
        TenantName?: string;
    }

    export namespace CreditConsumptionRow {
        export const idProperty = 'ID';
        export const localTextPrefix = 'Workspace.CreditConsumption';

        export namespace Fields {
            export declare const ID: string;
            export declare const TotalPurchased: string;
            export declare const TotalConsumed: string;
            export declare const Balance: string;
            export declare const InsertDate: string;
            export declare const TenantName: string;
        }

        ['ID', 'TotalPurchased', 'TotalConsumed', 'Balance', 'InsertDate', 'TenantName'].forEach(x => (<any>Fields)[x] = x);
    }
}
